// services/socket.js
import openSocket from "socket.io-client";
import { isObject } from "lodash";

export function socketConnection(params) {
  let userId = null;

  // Tenta pegar do localStorage
  if (typeof localStorage !== "undefined" && localStorage.getItem("userId")) {
    userId = localStorage.getItem("userId");
  }

  // Usa o userId do params, se existir, senão usa o do localStorage
  const finalUserId = isObject(params) ? params.userId || userId : userId;

  return openSocket(process.env.REACT_APP_BACKEND_URL, {
    transports: ["websocket"], //, "polling", "flashsocket"
    pingTimeout: 18000,
    pingInterval: 18000,
    query: {
      userId: finalUserId,
      ...(isObject(params) ? params : {})
    },
  });
}